/**
 *
 *   Error Catching:
 *    - catch JavaScript errors anywhere in their child component tree,
 *      log those errors, and display a fallback UI
 *    - DOES NOT CATCH ERRORS IN:
 *        - Event Handlers
 *        - Async Code
 *        - SSR
 *        - Errors thrown in the error boundary itself (rather than its children)
 *
 */
import { i18n } from "i18next";
import { useTranslation } from "react-i18next";

import { DesignSystemProvider, ErrorTile } from "chameleon/lib/components";

import { usePubSub } from "checkout-query-client/hooks/use-pub-sub";
import {
  PubSubMessage,
  PubSubNamespace,
} from "checkout-query-client/publish-subcriber/types";

export const ErrorFallback = ({ i18n }: { i18n?: i18n }) => {
  const { t } = useTranslation("combined", { i18n });
  const pubSub = usePubSub();
  const title = t("errorHandler.title");
  const caption = t("errorHandler.caption");
  pubSub.publish({
    level: "error",
    namespace: PubSubNamespace.unknown,
    message: PubSubMessage.UnknownError,
    payload: { message: "An unknown and uncaught error has occurred." },
  });
  return (
    <DesignSystemProvider>
      <ErrorTile title={title} caption={caption} />
    </DesignSystemProvider>
  );
};
